document.querySelectorAll("account-panel-page").forEach(element => {
	element.querySelectorAll(".highlight").forEach(highlightElement => {
		highlightElement.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	});
});
